import { z } from 'zod';

export const schemaPc24ImportResponse = z.object({
    // PC24 returns this as a JSON number (e.g. 415217) — normalize to string. (Confirmed against the
    // live endpoint.) Deliberately a union instead of z.coerce so booleans/objects fail the parse
    // instead of being laundered into a truthy "id".
    createdDatasetActionId: z.union([z.string(), z.number().int()]).transform(String).nullish(),
    // Only returned when the request carries targetProductId; absent for a plain processImport.
    directEntryUrl: z.string().optional(),
    entryUrl: z.string().optional(),
    errorMessage: z.string().nullish(),
    success: z.boolean(),
});

export type SchemaPc24ImportResponse = z.infer<typeof schemaPc24ImportResponse>;
